<template>
    <common-modal :heading="$t('forms.auth.signup.please_register')" headingCenter="true" width="wide">
        <common-content-wrapper width="medium">
            <common-content-spacer :isCenter="true" height="medium">
                <common-button
                    type="primary"
                    size="large-long"
                    :isProcessing="isLoading"
                    :label="$t('forms.auth.login.buttons.login')"
                    @click="goToLogin()"
                ></common-button>

                <h4 class="please-register__heading">
                    {{ $t('forms.auth.signup.no_account') }}
                </h4>
                <common-button
                    type="secondary"
                    size="large-long"
                    :isProcessing="isLoading"
                    :label="$t('forms.auth.signup.buttons.signup')"
                    @click="goToSignup()"
                ></common-button>
            </common-content-spacer>
        </common-content-wrapper>
    </common-modal>
</template>

<script>
    import RoutesEnum from 'enums/routes.enum'

    export default {
        props: {
            isLoading: { type: Boolean, default: false },
        },

        methods: {
            goToLogin() {
                localStorage.setItem('redirect', this.$route.fullPath)
                this.$router.push({ name: RoutesEnum.AUTH.LOGIN })
            },
            goToSignup() {
                localStorage.setItem('redirect', this.$route.fullPath)
                this.$router.push({ name: RoutesEnum.AUTH.SIGNUP })
            },
        },
    }
</script>

<style scoped lang="scss">
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/_mixins.scss';
    .please-register {
        &__heading {
            text-align: center;
            position: relative;

            &::before {
                content: '';
                display: block;
                width: 160px;
                height: 3px;
                background: $color-border-purple-1;
                left: 140px;
                top: 50%;
                position: absolute;
                transform: translateY(-50%);
                @include breakpoint(tablet) {
                    width: 130px;
                }
                @include breakpoint(smartphone-large) {
                    width: 30px;
                }
            }

            &::after {
                content: '';
                display: block;
                width: 160px;
                height: 3px;
                background: $color-border-purple-1;
                right: 140px;
                top: 50%;
                position: absolute;
                transform: translateY(-50%);
                @include breakpoint(tablet) {
                    width: 130px;
                }
                @include breakpoint(smartphone-large) {
                    width: 30px;
                }
            }
        }
    }
</style>
